/* REACT PACKAGE IMPORTS */
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

/* INTERNAL IMPORTS */
import QuestionHeader from "./QuestionHeader";
import QuestionComponent from "./QuestionComponent";

export default function ViewQuestion({
  position,
  questions,
  questionHeader,
  sessionId,
}) {
  const [isCalled, setIsCalled] = useState(false);
  const { answersSaved } = useSelector((store) => store.sessions);
  const mounted = useRef(null);

  useEffect(() => {
    mounted.current = true;
    if (mounted.current) {
      setIsCalled(true);
    }
    return () => (mounted.current = false);
  }, [answersSaved, isCalled]);

  return (
    <>
      {questionHeader && <QuestionHeader questionHeader={questionHeader} />}
      {questions.length > 0 &&
        questions.map((question, i) => {
          return (
            <div key={i} id={`container-${question.qid}`}>
              {isCalled && (
                <div className="background-secondary mb-3 p-3">
                  <QuestionComponent
                    position={position}
                    questionType={question?.qtype?.typename}
                    questionHeader={questionHeader}
                    question={question}
                    answers={answersSaved}
                    sessionId={sessionId}
                  />
                </div>
              )}
            </div>
          );
        })}
    </>
  );
}
